/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M1.9502 4.6284a.7552.7552 0 0 0-.8603-.4418l-.1297.0418a.7553.7553 0 0 0-.4418.8604l.0418.1296 2.7994 6.5951 6.5932-2.8004a.7552.7552 0 0 0-.4606-1.4317l-.1298.0419L5.281 9.3558a9.0879 9.0879 0 0 1 .9172-2.0189c1.0766-1.7604 2.7427-3.1348 4.7788-3.8358 4.7313-1.6292 9.8874.8856 11.5165 5.6169 1.6291 4.7312-.8857 9.8873-5.617 11.5164-2.2306.768-4.6194.634-6.7213-.3287a9.085 9.085 0 0 1-2.7764-1.9725.755.755 0 1 0-1.0903 1.0447 10.5966 10.5966 0 0 0 3.2379 2.3007c2.451 1.1226 5.2408 1.2791 7.8418.3836 5.5197-1.9006 8.4536-7.9161 6.553-13.4358-1.9006-5.5198-7.916-8.4537-13.4358-6.5531a10.5494 10.5494 0 0 0-5.8709 4.9909 10.6039 10.6039 0 0 0-.8055 1.9405L1.9502 4.6284Zm11.1833 5.6192 3.9962-3.9963a.755.755 0 0 1 1.0678 1.0678l-3.554 3.5539v7.2375a.755.755 0 1 1-1.51 0v-7.8629Z"
    clipRule="evenodd"
  />,
  'Restore'
);
